import { ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons';
import { Badge, Card, Col, Form, Input, message, Row, Select, Tabs } from 'antd';
import { Button } from 'components';
import { AddAgentEventModal } from 'features/users/components/modals/add-event-modal';
import { ProfileImageUpload } from 'features/users/components/modals/profile_image_upload_modal';
import { UpdateAdminUserModal } from 'features/users/components/modals/update-admin-user-modal';
import { useGetAgentEventList, useGetUser } from 'features/users/use-cases';
import { useEffect, useState } from 'react';
import { PermissionView } from './permission-list-view';
import { UserApiService } from 'features/users/api/user-api.service';
import { EventAcessAgent } from './eventaccess-agent';
import { useRoleAgent } from 'features/users/use-cases/get-role';
import { useCreateEventAgentRole } from 'features/users/use-cases/create-event-role';
import { useNavigate } from 'react-router-dom';
import camera from "assets/camera.svg"
const initialValue = '/static/media/No_Image_Available.e1ce751ef1b590f719f9.jpg';


export const AgentDetail = ({ id }: { id: string }) => {
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [profileModal, setProfileModal] = useState<boolean>(false);
  const [addEvent, setAddEvent] = useState<boolean>(false);
  const [profileImage, setProfileImage] = useState<any>(undefined);
  const [userPermissionData, setUserPermissionData] = useState('');
  const [activeTab, setActiveTab] = useState<any>("1");
  const [eventaccess, setEventAcces] = useState<any>('');
  const [loadingAccess, setEventAccessLoanding] = useState(true);
  const [filterForm] = Form.useForm();

  // API Queries
  const userQueryResult: any = useGetUser(id, { cacheTime: 0 });
  const { data: userData, refetch: EventRefetch } = userQueryResult;
  const { refetch: eventRefetch } = useGetAgentEventList(id);
  const { data } = useRoleAgent('')
  const { mutate } = useCreateEventAgentRole()
  const Navigate = useNavigate()
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);

  // const commonPayload = { AgentId: userData?.user_id };

  // const { data: eventaccessdata } = useCommonDropDownEventAcess({ ...commonPayload, flag: "sportcategory" });

  // MODALS HANDLERS
  const handleOpenModal = () => { setShowAddUserModal(true); document.body.style.overflow = 'hidden'; };
  const handleCloseModal = () => { setShowAddUserModal(false); document.body.style.overflow = 'visible'; };
  const [sportcategory, setSportCategory] = useState<any>('')
  const handleOpenProfileModal = () => { setProfileModal(true); document.body.style.overflow = 'hidden'; };
  const handleCloseProfileModal = () => { setProfileModal(false); document.body.style.overflow = 'visible'; };

  const handleOpenAddEventModal = () => { setAddEvent(true); document.body.style.overflow = 'hidden'; };
  const handleCloseEventModal = () => { setAddEvent(false); document.body.style.overflow = 'visible'; };

  // TAB HANDLER
  const tabItems = [
    { key: '1', label: <Button>Event Access</Button>, children: '' },
    { key: '2', label: <Button>Assign Role & Permissions</Button>, children: '' },
  ];

  const handleTabChange = (key: string) => {
    setActiveTab(key);
    if (key === "1" && userData?.user_id) initialAcess();
    if (key === "2") initial();
  };
  // INITIAL PERMISSION DATA
  const initial = async () => {
    try {
      const apires: any = await UserApiService().getRoleAgentDetail({ userId: id } as any);
      setUserPermissionData(apires);
    } catch (error) {
      console.error(error);
    }
  };

 
  // FETCH EVENT ACCESS
  const initialAcess = async (params?: any) => {
    const finalParams = {
      AgentId: userData?.user_id,
      Status: '',
      CategoryId: '',
      EventName: '',
      page,
      size,
      ...params, // ← override dynamically when passed
    };

    try {
      setEventAccessLoanding(true);
      const apires = await UserApiService().getRoleAgentDetailEventAccess(
        // params || { AgentId: userData?.user_id, Status: '', CategoryId: '', EventName: '', page: 1, size: 10 }
        finalParams
      );
      setEventAcces(apires);
    } catch (error: any) {
      message.error(error.message || "Something went wrong");
    } finally {
      setEventAccessLoanding(false);
    }
  };

  // FILTER HANDLER
  const handleFilter = () => {
    const values = filterForm.getFieldsValue();
    const filteredParams = {
      AgentId: userData?.user_id,
      Status: values.status || '',
      CategoryId: values.categoryId || '',
      EventName: values.eventName || '',
      page: 1,
      size: 10,
    };
    initialAcess(filteredParams);
  };

  const handleClear = () => {
    filterForm.resetFields();
    initialAcess();
  };

  // INITIAL DATA LOAD
  useEffect(() => { initial(); }, []);
  useEffect(() => { if (userData?.user_id) initialAcess(); }, [userData?.user_id]);
  const handleChange = (value: any) => {
    const payload = {
      agentId: id,
      roleId: value
    }
    mutate(payload, {
      onSuccess: (data1: any) => {
        message.success(data1.ResponseMessage)

        EventRefetch()
        initialAcess()
      }
    })
  }
  const initialCategory = async () => {
  try {
    const agentId = userData?.user_id;
    const Param={
      flag: "adminsportcategory",
      AgentId: agentId,
    }

    const apires: any = await UserApiService().getcommonDropDown(Param);
    setSportCategory(apires);
  } catch (error: any) {
    message.error(error?.message || "Something went wrong");
  }
};
useEffect(() => {
  if (userData?.user_id) {
    initialCategory();
  }
}, [userData?.user_id]);

  return (
    <>
      {/* PROFILE CARD */}
      <Card className="prfle_crd " title={
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <ArrowLeftOutlined
            style={{ fontSize: 20, cursor: "pointer" }}
            onClick={() => Navigate("/users/agent")}
          />
          <span>My Profile</span>
        </div>
      } extra={<Button onClick={handleOpenModal}> Edit </Button>}>
        <div className="profile_data prf_btn new_cb">
          <div className="prf_img new_img_B">
            <div className="prf_img_bx new_img_bx">
              <img
                src={profileImage ?? (userData?.profile_picture || initialValue)}
                alt=""
              />
            </div>
            <Button className="btn" onClick={handleOpenProfileModal}>
              <img src={camera} />
            </Button>
          </div>


          <div className='bsic_info'>
            <div className='pr_info'>
              {/* <h3 className='basic_head'>Basic Information</h3> */}
              <div className="user_d">
                <p>First Name : <span>{userData?.first_name}</span></p>
                <p>Last Name : <span>{userData?.last_name}</span></p>
                <p>Mobile No : <span>{userData?.phone_number}</span></p>
                <p>Email : <span>{userData?.email}</span></p>

                <p>Role : <span>{userData?.role}</span></p>
                <p style={{ width: '100%' }}>Address : <span>{userData?.address}</span></p>
              </div>
            </div>

            {/* <div className='add_info'>
              <h3 className='basic_head'>Address Details</h3>
              <div className="user_d">

               

              </div>
            </div> */}
          </div>
        </div>
      </Card>

      {/* TAB + FILTER CARD */}
      <Card style={{ borderRadius: 10, marginBottom: "15px" }}>
        <div className="box_hd">
          <Tabs items={tabItems} className='agent_tab' activeKey={activeTab} onChange={handleTabChange} style={{ marginBottom: 10 }} />
          {activeTab === "1" && <Button onClick={handleOpenAddEventModal}><PlusOutlined /> Add Event</Button>}
        </div>

        {/* FILTER FORM */}
        {activeTab == "1" &&
          <div>
            <>
              {/* <h4 style={{ marginBottom: "5px", fontWeight: 500 }}>Filter by</h4> */}
              <Form layout="vertical" form={filterForm}>
                <Row gutter={16} align="middle">
                  <Col span={4}>
                    <Form.Item name="eventName" label="Event Name" className='frm_item'>
                      <Input placeholder="Enter event name" />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item name="categoryId" label="Sport Category" className='frm_item'>
                      <Select
                        placeholder="--Select Category--"
                        style={{ width: "100%" }}
                        options={sportcategory?.dropDownList?.map((item: any) => ({ label: item.Name, value: item.Id }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item name="status" label="Status" className='frm_item'>
                      <Select
                        placeholder="--Select Status--"

                        options={[
                          { value: 'true', label: 'Active' },
                          { value: 'false', label: 'InActive' },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <div style={{ display: "flex", gap: 12, marginTop: "30px" }}>
                      <Button type="primary" onClick={handleFilter} style={{ background: "#000", borderColor: "#000", padding: "0 24px", fontWeight: 500 }}>Filter</Button>
                      <Button onClick={handleClear} style={{ background: "#fff", border: "1px solid #aaa", padding: "0 24px", fontWeight: 500 }}>Clear</Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </>
            {activeTab == 2 &&
              <Form layout="vertical" form={filterForm}>
                <Row gutter={16} align="middle">

                  <Col span={5}>
                    <Form.Item name="Role" label="Role">
                      <Select
                        placeholder="--Select Role--"
                        style={{ width: "100%" }}
                        onChange={handleChange}
                        options={data?.items?.map((item: any) => ({
                          label: item.role_name,
                          value: item.id,
                        }))}
                      />
                    </Form.Item>
                  </Col>

                </Row>
              </Form>}
          </div>}

      </Card>

      {/* EVENT LIST */}
      {activeTab === "1" && (
        <Card title={<span>Event List <Badge count={eventaccess?.total} showZero color="green" /></span>}>
          <EventAcessAgent eventAcessData={eventaccess} loadingAccess={loadingAccess} agentId={userData?.user_id}
            initialAcess={initialAcess} page={page} size={size} setPage={setPage} setSize={setSize} />
        </Card>
      )}

      {/* PERMISSIONS TAB */}
      {activeTab === "2" && (
        <PermissionView
          userPermissionData={userPermissionData}
          setUserPermissionData={setUserPermissionData}
          id={id}
          userData={userData}
          data={data} EventRefetch={EventRefetch} 
          initial={initial}
          />
      )}

      {/* MODALS */}
      {showAddUserModal && (
        <div className={`cstmrightmdl ${showAddUserModal && "show"}`}>
          <UpdateAdminUserModal id={id} onClose={handleCloseModal} onSuccess={handleCloseModal} />
        </div>
      )}

      <div className={`cstmrightmdl upld_modl ${profileModal && "show"}`}>
        <ProfileImageUpload id={id} onClose={handleCloseProfileModal} gallaryModal={profileModal} setProfileImage={setProfileImage} />
      </div>

      <div className={`cstmrightmdl upld_modl ${addEvent && "show"}`}>
        <AddAgentEventModal onClose={handleCloseEventModal} agentId={userData?.user_id} agentId_={id} eventRefetch={eventRefetch} initialAcess={initialAcess} />
      </div>
    </>
  );
};
